<template>
    <div class="block block-bordered">
        <div class="block-header block-header-default">
            <div class="block-title">
                <h2 class="content-heading">Register an Employee</h2>
            </div>
        </div>

        <div class="block-content">
            <!--            <form v-on:submit="saveForm()">-->
            <!--                <div class="form-group">-->
            <!--                    <label for="employee_name">Employee Name </label>-->
            <!--                    <input type="text" class="form-control" id="employee_name" v-model="form.employee_name" required>-->
            <!--                </div>-->

            <!--                <div class="form-group">-->
            <!--                    <label for="employee_position">Employee Position </label>-->
            <!--                    <input type="text" class="form-control" id="employee_position" v-model="form.employee_position"-->
            <!--                           required>-->
            <!--                </div>-->

            <!--                <div class="form-group">-->
            <!--                    <label for="employee_number">Employee Number </label>-->
            <!--                    <input type="text" class="form-control" id="employee_number" v-model="form.employee_number"-->
            <!--                           required>-->
            <!--                </div>-->

            <!--                <div class="form-group">-->
            <!--                    <label for="employee_residence">Employee Residence </label>-->
            <!--                    <input type="text" class="form-control" id="employee_residence" v-model="form.employee_residence"-->
            <!--                           required>-->
            <!--                </div>-->

            <!--                <div class="form-group">-->
            <!--                    <label for="employee_residence">Employee MSISDN </label>-->
            <!--                    <input type="text" class="form-control" id="employee_msisdn" v-model="form.employee_msisdn"-->
            <!--                           required>-->
            <!--                </div>-->

            <!--                <div class="form-group">-->
            <!--                    <label for="employee_id_number">Employee ID Number </label>-->
            <!--                    <input type="phone" class="form-control" id="employee_id_number" v-model="form.employee_id_number"-->
            <!--                           required>-->
            <!--                </div>-->

            <!--                <div class="form-group">-->
            <!--                    <label for="employee_work_email">Employee Work Email </label>-->
            <!--                    <input type="phone" class="form-control" id="employee_work_email" v-model="form.employee_work_email"-->
            <!--                           required>-->
            <!--                </div>-->

            <!--                <div class="form-group">-->
            <!--                    <label for="employee_personal_email">Employee Personal Email </label>-->
            <!--                    <input type="phone" class="form-control" id="employee_personal_email"-->
            <!--                           v-model="form.employee_personal_email" required>-->
            <!--                </div>-->

            <!--                <div class="block-content block-content-sm block-content-full bg-body-light rounded-bottom">-->
            <!--                    <div class="form-group">-->
            <!--                        <button type="submit" class="btn btn-primary">-->
            <!--                            <i class="fa fa-check mr-1"></i> Submit-->
            <!--                        </button>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </form>-->

            <el-form :label-position="labelPosition" label-width="100px" :model="form">
                <el-form-item label="Employee Name">
                    <el-input v-model="form.employee_name" placeholder="Employee Name"></el-input>
                </el-form-item>
                <el-form-item label="Employee Position">
                    <el-input v-model="form.employee_position" placeholder="Employee Position"></el-input>
                </el-form-item>
                <el-form-item label="Employee Number">
                    <el-input v-model="form.employee_number" placeholder="Employee Number"></el-input>
                </el-form-item>
                <el-form-item label="Employee Residence">
                    <el-input v-model="form.employee_residence" placeholder="Employee Residence"></el-input>
                </el-form-item>
                <el-form-item label="Employee Mobile Number (Safaricom.)">
                    <el-input v-model="form.employee_msisdn"
                              placeholder="Employee Mobile Number (Safaricom.)"></el-input>
                </el-form-item>
                <el-form-item label="Employee ID Number">
                    <el-input v-model="form.employee_id_number" placeholder="Employee ID Number"></el-input>
                </el-form-item>
                <el-form-item label="Employee Work Email">
                    <el-input v-model="form.employee_work_email" placeholder="Employee Work Email"></el-input>
                </el-form-item>
                <el-form-item label="Employee Personal Email">
                    <el-input v-model="form.employee_personal_email" placeholder="Employee Personal Email"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="saveForm">Create Employee</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {APP_CONFIG} from "../../config";
    import {Loading} from 'element-ui';
    import {Message} from 'element-ui';

    export default {
        name: "SalaryAdvanceRequests",
        data: function () {
            return {
                form: {
                    employee_name: '',
                    employee_position: '',
                    employee_number: '',
                    employee_residence: '',
                    employee_msisdn: '',
                    employee_id_number: '',
                    employee_work_email: '',
                    employee_personal_email: '',
                    snackbar_message: '',
                },
                labelPosition: 'top',
                items: [],
            }
        },
        methods: {
            saveForm() {
                event.preventDefault();
                var app = this;
                let formData = new FormData();
                let loadingInstance = Loading.service({fullscreen: true});

                formData.append('project', this.$route.params.project);
                formData.append('employee_name', this.form.employee_name);
                formData.append('employee_number', this.form.employee_number);
                formData.append('employee_position', this.form.employee_position);
                formData.append('employee_residence', this.form.employee_residence);
                formData.append('employee_msisdn', this.form.employee_msisdn);
                formData.append('employee_id_number', this.form.employee_id_number);
                formData.append('employee_work_email', this.form.employee_work_email);
                formData.append('employee_personal_email', this.form.employee_personal_email);

                axios.post(`${APP_CONFIG.URL}projects/` + this.$route.params.project + `/salary_advance/register_salary_advance_employee`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(function (resp) {
                    console.log('SUCCESS!!');
                    console.log(JSON.stringify(resp));
                    loadingInstance.close();
                    Message.success("User Registered Successfully");
                }).catch(error => {
                    console.log(error.response);
                    console.log("Status Response " + error.response.data.message);
                    Message.error(error.response.data.message);
                    loadingInstance.close();
                    Message.error("An Error Occurred");
                })
                    .catch(function (resp) {
                        console.log('FAILURE!!');
                        loadingInstance.close();
                        Message.error("An Error Occurred");
                    });
            }
        }
    }
</script>

<style scoped>

</style>
